// Order matters: Edge, Opera and Samsung Internet also claim to be Chrome, and Chrome claims to be Safari.
const BROWSERS = [
  ['Edge', /Edg(e|A|iOS)?\//],
  ['Opera', /OPR\/|Opera/],
  ['Samsung Internet', /SamsungBrowser\//],
  ['Firefox', /Firefox\/|FxiOS\//],
  ['Chrome', /Chrome\/|CriOS\//],
  ['Safari', /Safari\//],
];

// Android user agents also contain "Linux", and iPhones "like Mac OS X".
const OPERATING_SYSTEMS = [
  ['iOS', /iPhone|iPod/],
  ['iPadOS', /iPad/],
  ['Android', /Android/],
  ['ChromeOS', /CrOS/],
  ['Windows', /Windows/],
  ['macOS', /Macintosh|Mac OS X/],
  ['Linux', /Linux/],
];

const findName = (candidates, userAgent) => candidates.find(([, pattern]) => pattern.test(userAgent))?.[0];

/**
 * A human-readable label for this browser, e.g. "Chrome on macOS", shown to the user when another device
 * wants to take over their account. Never anything user-identifying.
 */
export const getDeviceLabel = () => {
  const { userAgent = '', maxTouchPoints = 0 } = window.navigator;
  const browser = findName(BROWSERS, userAgent);
  let os = findName(OPERATING_SYSTEMS, userAgent);

  // iPadOS asks for desktop sites by default and reports itself as a Mac
  if (os === 'macOS' && maxTouchPoints > 1) {
    os = 'iPadOS';
  }

  if (browser && os) {
    return `${browser} on ${os}`;
  }

  return browser || os || '';
};
